<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      isSubOpen: false,
      // isSubChildOpen: [],
      isProductsSubOpen: false,
    }
  },
  methods: {
    goTo(to) {
      this.$router.push(to)
    },
    goToSolution(category) {
      this.$router.push({
        name: 'solution-list',
        query: {
          filterCategory: category,
        },
      })
    },
    goToFilter(name, alias) {
      const router = () => {
        switch (name) {
          case 'brand-list':
          case 'brand-category':
            return {
              name: 'brand-category',
              params: {
                categoryAlias: alias,
              },
            }
          case 'product-list':
            return {
              name: 'product-list',
              query: {
                filterCategory: alias,
              },
            }
        }
      }
      this.$router.push({
        ...router(),
      })
    },
    changeMenuPage({ title, alias, description, list, name }) {
      this.$emit('changeMenuPage', { title, alias, description, list, name })
    },
    changeSubChildOpen(index, change) {
      this.isSubChildOpen.splice(index, 1, change)
    },
  },
}
</script>
<template>
  <div :class="$style.menuToggle">
    <div v-if="item.path" class="menuToggle__header">
      <a class="link" :href="item.path" target="_blank">
        <span class="menuToggle__headerText pr-2">{{ item.text }}</span>
        <i class="fal fa-external-link-alt menuToggle__headerIcon"></i>
      </a>
    </div>
    <div v-else-if="item.url" class="menuToggle__header">
      <a class="link" :href="item.url">
        <span>{{ item.text }}</span>
      </a>
    </div>
    <div v-else :class="{ isOpen: isOpen }" class="menuToggle__header">
      <router-link v-if="item.to" :to="item.to" class="menuToggle__headerText">{{ item.text }}</router-link>
      <span v-else class="menuToggle__headerText">{{ item.text }}</span>
      <template v-if="item.type === 'mega' || item.children">
        <i v-if="!isOpen" class="fal fa-chevron-down menuToggle__headerIcon" @click.stop.prevent="isOpen = true"> </i>
        <i v-else class="fal fa-chevron-up menuToggle__headerIcon" @click.stop.prevent="isOpen = false"> </i>
      </template>
    </div>
    <div class="menuToggle__content" :class="{ isOpen: isOpen }">
      <template v-if="item.type === 'mega'">
        <div :class="$style.subMenuList">
          <template v-if="item.data.type === 'b'">
            <div v-for="(subMenuItem, index) in item.data.list" :key="index" class="subMenuList__item" @click="goToSolution(subMenuItem.alias)">
              <span style="cursor: pointer">{{ subMenuItem.title || subMenuItem.text }}</span>
              <i
                class="fal fa-chevron-right pl-2"
                @click.stop.prevent="
                  changeMenuPage({
                    title: `${item.text} - ${subMenuItem.title}`,
                    alias: subMenuItem.alias,
                    description: subMenuItem.description,
                    list: subMenuItem.industry_category,
                    name: item.to.name,
                  })
                "
              >
              </i>
            </div>
          </template>
          <template v-if="item.data.type === 'a'">
            <template v-for="(subMenuItem, index) in item.data.list">
              <div v-if="subMenuItem.path" :key="index" class="subMenuList__item">
                <a :href="subMenuItem.path" target="_blank" class="color-gray-7 text-decoration-none link"> {{ subMenuItem.text }} <i class="fal fa-external-link-alt"></i> </a>
              </div>
              <div
                v-else-if="(subMenuItem.to && subMenuItem.alias === 'brands') || (subMenuItem.to && subMenuItem.alias === 'products')"
                :key="index"
                class="subMenuList__item"
                @click="goTo(subMenuItem.to)"
              >
                {{ subMenuItem.text || subMenuItem.title }}
                <template v-if="subMenuItem.data">
                  <i
                    class="fal fa-chevron-right menuToggle__headerIcon pl-2"
                    @click.stop.prevent="
                      changeMenuPage({
                        title: `${item.text} - ${subMenuItem.text}`,
                        alias: subMenuItem.alias,
                        list: subMenuItem.data.list,
                        name: subMenuItem.to.name,
                      })
                    "
                  >
                  </i>
                </template>
              </div>
              <!-- <div
                v-else-if="subMenuItem.to && subMenuItem.alias === 'products'"
                :key="index"
                class="subMenuList__item"
                @click="isProductsSubOpen = !isProductsSubOpen"
              >
                {{ subMenuItem.text || subMenuItem.title }}
                <template v-if="subMenuItem.data">
                  <i
                    v-if="!isProductsSubOpen"
                    class="fal fa-chevron-right menuToggle__headerIcon"
                    @click.stop.prevent="isProductsSubOpen">
                  </i>
                  <i
                    v-else
                    class="fal fa-chevron-down menuToggle__headerIcon"
                    @click.stop.prevent="!isProductsSubOpen">
                  </i>
                </template>
              </div> -->
              <div v-else :key="index" class="subMenuList__item" @click="goTo(subMenuItem.to)">
                {{ subMenuItem.text || subMenuItem.title }}
              </div>
            </template>
          </template>
        </div>
      </template>
      <template v-if="item.type === 'nav'">
        <ul :class="$style.subMenuList">
          <li v-for="(subMenuItem, $index) in item.children" :key="$index" class="subMenuList__item d-block" @click="goTo(subMenuItem.to)">
            <template v-if="subMenuItem.children">
              <div :class="$style.subMenuToggle">
                <div :class="{ isOpen: isSubOpen }" class="subMenuToggle__header" @click="goTo(subMenuItem.to)">
                  <span class="subMenuToggle__headerText">{{ subMenuItem.text }}</span>
                  <i v-if="!isSubOpen" class="fal fa-chevron-down subMenuToggle__headerIcon" @click.stop.prevent="isSubOpen = true"> </i>
                  <i v-else class="fal fa-chevron-up subMenuToggle__headerIcon" @click.stop.prevent="isSubOpen = false"> </i>
                </div>
                <div class="subMenuToggle__content" :class="{ isOpen: isSubOpen }">
                  <ul :class="$style.subMenuList">
                    <li v-for="subMenuItem2 in subMenuItem.children" :key="subMenuItem2.text" class="subMenuList__item" @click.stop.prevent="goTo(subMenuItem2.to)">
                      <span>{{ subMenuItem2.text }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <span v-else>{{ subMenuItem.text }}</span>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>
<style lang="scss" module>
.menuToggle {
  :global {
    .menuToggle {
      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 0.25rem;
        border-bottom: 1px solid $color-gray-2;
        transition: color 0.3s;

        &.isOpen {
          color: $color-primary;
        }

        &:hover {
          color: $color-primary;
        }
        .link {
          &:hover,
          &:active {
            color: $color-primary;
            text-decoration: none;
          }
          color: $color-gray-7;
          transition: 0.3s;
        }
      }

      &__headerText {
        color: #1D293F;
        font-size: 1rem;
      }

      &__headerIcon {
      }

      &__content {
        max-height: 0;
        padding: 0 0.25rem;
        overflow: hidden;
        transition: max-height 0.3s;

        &.isOpen {
          max-height: 2000px;
        }
      }
    }
  }
}

.subMenuToggle {
  :global {
    .subMenuToggle {
      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: color 0.3s;

        &.isOpen {
          color: $color-primary;
        }

        &:hover {
          color: $color-primary;
        }
      }

      &__headerText {
        font-size: 1rem;
      }

      &__headerIcon {
      }

      &__content {
        max-height: 0;
        padding: 0 0.25rem;
        overflow: hidden;
        transition: max-height 0.3s;

        &.isOpen {
          max-height: 600px;
        }
      }
    }

    .subMenuList {
      &__item {
        padding-left: 0.5rem !important;
        background: rgba(#000, 4%);

        &:hover {
          color: $color-primary;
        }
      }
    }
  }
}

.subMenuList {
  @include list-unstyled;

  padding: 1rem 0;

  :global {
    .subMenuList {
      &__item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.75rem 0.25rem;
        font-size: 1rem;
        padding-left: 1rem;
        &:hover {
          color: $color-primary;
        }
        .link {
          &:hover,
          &:active {
            color: $color-primary;
          }
        }
        @include max-md {
          font-size: 0.875rem;
        }
      }

      &__subList {
        max-height: 0;
        padding: 0 0.25rem;
        overflow: hidden;
        transition: max-height 0.3s;

        &.isOpen {
          max-height: 1000px;
          border-bottom: 1px solid $color-gray-2;
        }
      }

      &__subItem {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.75rem 0.25rem 0.75rem 1.25rem;
        font-size: 1rem;
        @include max-md {
          font-size: 0.875rem;
        }
        &:hover {
          color: $color-primary;
        }
      }
    }
  }
}
</style>
